<template>
  <div class="create-post-comp">
    <div class="d-flex mb-5 align-items-center mob-shadow">
      <font-awesome-icon
        :icon="['far', 'arrow-left']"
        class="cp gray400 mr-4"
        @click="changeScreen('moreOptions')"
      />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">What are you celebrating?</h4>
      <font-awesome-icon
        size="2x"
        :icon="['fal', 'times']"
        class="font-black ml-auto cp font20"
        @click="hide"
      />
    </div>
    <div
      v-for="celebration in typesOfCelebrations"
      :key="celebration.name"
      class="cp bg-gray50 p-3 rounded d-flex align-items-center mb-2 font14 fw700 gray500"
      @click="changeScreen('add', 'celebration', celebration.name)"
    >
      <img src="../../../assets/emojis/confetti-24.png" alt="confetti" class="mr-2 hw24" />
      {{ celebration.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CelebrationsScreen",
  props: { changeScreen: Function, selectedCelebration: String, hide: Function },
  data() {
    return {
      typesOfCelebrations: [
        { name: "New position" },
        { name: "Work anniversary" },
        { name: "Publication" },
        { name: "Birthday" },
        { name: "Victory" },
        { name: "Graduation" },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.bg-gray50 {
  &:hover {
    background: #cbd5e1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/Celebrations.vue